/**
 * Maps constants doc
 */
/**
 * Specifies the maps load event name.
 * @private
 */
export var load = 'load';
/**
 * Specifies the maps loaded event name.
 * @private
 */
export var loaded = 'loaded';
/**
 * Specifies the maps click event name.
 * @private
 */
export var click = 'click';
/**
 * Specifies the maps right click event name.
 * @private
 */
export var rightClick = 'rightClick';
/**
 * Specifies the maps double click event name.
 * @private
 */
export var doubleClick = 'doubleClick';
/**
 * Specifies the maps resize event name.
 * @private
 */
export var resize = 'resize';
/**
 * Specifies the maps tooltip event name.
 */
export var tooltipRender = 'tooltipRender';
/**
 * Specifies the map shape selected event.
 */
export var shapeSelected = 'shapeSelected';
/**
 * Specifies the maps shape highlight event.
 */
export var shapeHighlight = 'shapeHighlight';
/**
 * Specifies the maps mouse move event name.
 * @private
 */
export var mousemove = 'mousemove';
/**
 * Specifies the maps mouse up event name.
 * @private
 */
export var mouseup = 'mouseup';
/**
 * Specifies the maps mouse down event name.
 * @private
 */
export var mousedown = 'mousedown';
/**
 * Specifies the maps layer rendering event name.
 * @private
 */
export var layerRendering = 'layerRendering';
/**
 * Specifies the maps shape rendering event name.
 * @private
 */
export var shapeRendering = 'shapeRendering';
/**
 * Specifies the maps marker rendering event name.
 * @private
 */
export var markerRendering = 'markerRendering';
/**
 * Specifies the maps cluster rendering event name.
 * @private
 */
export var markerClusterRendering = 'markerClusterRendering';
/**
 * Specifies the maps marker click event name.
 * @private
 */
export var markerClick = 'markerClick';
/**
 * Specifies the maps cluster click event name.
 * @private
 */
export var markerClusterClick = 'markerClusterClick';
/**
 * Specifies the maps marker mouse move event name.
 * @private
 */
export var markerMouseMove = 'markerMouseMove';
/**
 * Specifies the maps cluster mouse move event name.
 * @private
 */
export var markerClusterMouseMove = 'markerClusterMouseMove';
/**
 * Specifies the maps data label rendering event name.
 * @private
 */
export var dataLabelRendering = 'dataLabelRendering';
/**
 * Specifies the maps bubbleRendering event name.
 * @private
 */
export var bubbleRendering = 'bubbleRendering';
/**
 * Specifies the maps bubble click event name.
 * @private
 */
export var bubbleClick = 'bubbleClick';
/**
 * Specifies the maps bubble mouse move event name.
 * @private
 */
export var bubbleMouseMove = 'bubbleMouseMove';
/**
 * Specifies the maps animation complete event name.
 * @private
 */
export var animationComplete = 'animationComplete';
/**
 * Specifies the maps legend rendering event name.
 * @private
 */
export var legendRendering = 'legendRendering';
/**
 * Specifies the maps annotation rendering event name.
 * @private
 */
export var annotationRendering = 'annotationRendering';
/**
 * Specifies the maps item selection event name.
 * @private
 */
export var itemSelection = 'itemSelection';
/**
 * Specifies the maps item highlight event name.
 */
export var itemHighlight = 'itemHighlight';
/**
 * Specifies the maps before print event name.
 */
export var beforePrint = 'beforePrint';
/**
 * Specifies the maps zoom in event name.
 */
export var zoomIn = 'zoomIn';
/**
 * Specifies the maps zoom out event name.
 */
export var zoomOut = 'zoomOut';
/**
 * Specifies the maps pan event name.
 */
export var pan = 'pan';
